import type { Recipe } from '../../types'
import { image, ingredient, section } from '../helpers'

export const gnocchisALitalienne: Recipe = {
  slug: 'gnocchis-a-litalienne',
  title: 'Gnocchis à l’italienne',
  category: 'salé',
  description: 'Des gnocchis maison aux pommes de terre, pour 4 à 6 personnes.',
  image: image('gnocchis'),
  tags: ['pommes de terre', 'pâtes', 'maison'],
  meta: [
    { label: 'Préparation', value: '20 minutes' },
    { label: 'Cuisson', value: '30 minutes + 10 minutes' },
  ],
  sections: [
    section('Ingrédients', [
      ingredient('pommes-de-terre', 'pommes de terre à purée', '1 kg de pommes de terre à purée', {
        amount: 1,
        unit: 'kg',
        shoppingKey: 'pommes de terre',
      }),
      ingredient('farine', 'farine', '400 g de farine', { amount: 400, unit: 'g', shoppingKey: 'farine' }),
      ingredient('œuf', 'œuf', '1 œuf', { amount: 1, unit: 'œuf', shoppingKey: 'œuf' }),
      ingredient('huile', 'huile', '1 cuillère à soupe d’huile'),
      ingredient('beurre', 'beurre', '50 g de beurre', { amount: 50, unit: 'g', shoppingKey: 'beurre' }),
      ingredient('muscade', 'noix de muscade', 'Noix de muscade'),
      ingredient('assaisonnement', 'sel et poivre', 'Sel et poivre'),
    ]),
  ],
  steps: [
    'Faire cuire les pommes de terre. Dans le bol du KitchenAid, mettre les pommes de terre épluchées ainsi que le reste des ingrédients. Utiliser le batteur plat à vitesse 2 pendant 2 minutes. Ajuster si besoin la quantité de farine. Sortir la pâte du bol à la manière de la pâte à pain.',
    'Former des saucissons de pâte d’environ 0,5 cm de diamètre. Les marquer à la fourchette puis les fariner et les couper en tronçons de 1 cm.',
    'Pocher les gnocchis dans une grande quantité d’eau frémissante salée. Lorsqu’ils remontent en surface, ils sont cuits.',
    'Après les avoir égouttés, les faire revenir au beurre dans une poêle.',
  ],
}
